import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Download, File, FileText, Trash2, Upload } from "lucide-react";
import { formatFileSize } from "..";

const DocumentDialogSection = ({ ctx }) => {
  const {
    docForm,
    documentDialogOpen,
    documentTypes,
    employeeDocuments,
    formatFileSize,
    handleDocumentDelete,
    handleDocumentDownload,
    handleDocumentUpload,
    selectedEmployeeForDocs,
    setDocForm,
    setDocumentDialogOpen,
    uploadingDoc
  } = ctx;
  return (
    <>
      <Dialog open={documentDialogOpen} onOpenChange={setDocumentDialogOpen}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl">
              EMPLOYEE DOCUMENTS
              {selectedEmployeeForDocs && (
                <span className="text-base font-normal text-slate-600 ml-2">
                  - {selectedEmployeeForDocs.name} ({selectedEmployeeForDocs.employee_code})
                </span>
              )}
            </DialogTitle>
          </DialogHeader>
          
          {/* Upload Form */}
          <form onSubmit={handleDocumentUpload} className="space-y-4 mt-4 p-4 bg-slate-50 rounded-sm">
            <h3 className="font-heading font-bold text-sm uppercase tracking-widest text-slate-700">Upload New Document</h3>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Document Type *</label>
                <select
                  required
                  value={docForm.document_type}
                  onChange={(e) => setDocForm({...docForm, document_type: e.target.value})}
                  className="w-full px-3 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                >
                  <option value="">Select Type</option>
                  {documentTypes.map(type => (
                    <option key={type} value={type}>{type}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Document Name</label>
                <input
                  type="text"
                  value={docForm.document_name}
                  onChange={(e) => setDocForm({...docForm, document_name: e.target.value})}
                  className="w-full px-3 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                  placeholder="Optional custom name"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">File (PDF/JPG/PNG) *</label>
                <input
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={(e) => setDocForm({...docForm, file: e.target.files[0]})}
                  className="w-full px-3 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                />
              </div>
            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                disabled={uploadingDoc}
                className="btn-primary flex items-center space-x-2 text-sm"
              >
                <Upload className="w-4 h-4" />
                <span>{uploadingDoc ? "Uploading..." : "Upload Document"}</span>
              </button>
            </div>
          </form>

          {/* Documents List */}
          <div className="mt-6">
            <h3 className="font-heading font-bold text-sm uppercase tracking-widest text-slate-700 mb-4">
              Uploaded Documents ({employeeDocuments.length})
            </h3>
            {employeeDocuments.length > 0 ? (
              <div className="space-y-2">
                {employeeDocuments.map(doc => (
                  <div key={doc.id} className="flex items-center justify-between p-3 bg-white border border-slate-200 rounded-sm hover:bg-slate-50">
                    <div className="flex items-center space-x-3">
                      <div className="p-2 bg-primary/10 rounded-sm">
                        <FileText className="w-5 h-5 text-primary" />
                      </div>
                      <div>
                        <p className="font-medium text-sm">{doc.document_name}</p>
                        <p className="text-xs text-slate-500">
                          {doc.document_type} • {formatFileSize(doc.file_size)} • {new Date(doc.uploaded_at).toLocaleDateString()}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => handleDocumentDownload(doc)}
                        className="p-2 hover:bg-slate-200 rounded-sm"
                        title="Download"
                      >
                        <Download className="w-4 h-4 text-primary" />
                      </button>
                      <button
                        onClick={() => handleDocumentDelete(doc)}
                        className="p-2 hover:bg-red-100 rounded-sm"
                        title="Delete"
                      >
                        <Trash2 className="w-4 h-4 text-error" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-8 text-slate-500">
                <File className="w-12 h-12 mx-auto mb-3 text-slate-300" />
                <p>No documents uploaded yet</p>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DocumentDialogSection;
